import 'whatwg-fetch';
import implement from 'implement-js'
import {ItemData} from 'domain/Mapping/itemData';
import {isRunningOnCTE} from './utils'

const apiKey = '9aebdb58-fad2-4569-90bd-0d4a8fd9903c';
const appId = 'cwcalc';
const validItemsOnly = true;
const fields = 'image%2C%20priceUnit%2C%20genericProduct%2C%20measureReference%2C%20measure%2C%20priceInformation%2C%20child';

export const GENERAL_ERROR_DEXF_ITEM_DATA = 'DEXF_ITEM_DATA_ERROR';

export function createDEXFRequestError() {
  const error = new Error('There was an error fetching item data from DEXF.');
  error.name = GENERAL_ERROR_DEXF_ITEM_DATA;
  return error;
}

export const dexfRequest = (country, language, businessRules) => {
  const prodUrl = `https://api.dexf.ikea.com/webplanner/v1/query/items/retailunit/${country.toUpperCase()}/locale/${language}-${country.toUpperCase()}?fields=${fields}&filter.appId=${appId}&filter.valid=${validItemsOnly}`;
  const localhostUrl = `/addon-app/cwcalc/items/latest/${country}/${language}/index.json`;
  const cteLatestRefUrl = `/addon-app/cwcalc/items/latest/index.json`;

  let response;

  if(process.env.ITEMS_ENV === 'local'){
    response = fetchItemData(localhostUrl)
      .then((response) => {
        if (response.length === 0) {
          throw createDEXFRequestError();
        }
        console.log(`Successfully fetched localized item data for unit: ${country.toUpperCase()} locally.`);
        return remapItemData(response,businessRules);
      });
  } else if (isRunningOnCTE) {
    response = fetchSameOriginJson(cteLatestRefUrl)
      .then((latestRef) => {
        console.log('Fetched latestRef:', latestRef);

        const key = `${language.toLowerCase()}_${country.toUpperCase()}`;
        const latestFile = latestRef[key];
        if (latestFile) {
          const fileUrl = `/addon-app/cwcalc/items/${latestFile}.json`;
          console.log('Fetching item data from:', fileUrl);

          return fetchSameOriginJson(fileUrl)
            .then((response) => {
              if (response) {
                console.log(`Successfully fetched localized item data for unit: ${country.toUpperCase()} locally from server.`);
                return remapItemData(response,businessRules);
              } else {
                console.log('File not found on server. Falling back to DEXF API.');
                return fetchItemData(prodUrl)
                  .then((response) => {
                    if (response.length === 0) {
                      throw createDEXFRequestError();
                    }
                    console.log(`Successfully fetched item data for unit: ${country.toUpperCase()} from DEXF.`);
                    return remapItemData(response,businessRules);
                  });
              }
            });
        } else {
          console.log(`No latestRef item data entry found for key: ${key}. Falling back to DEXF API.`);
          return fetchItemData(prodUrl)
            .then((response) => {
              if (response.length === 0) {
                throw createDEXFRequestError();
              }
              console.log(`Successfully fetched item data for unit: ${country.toUpperCase()} from DEXF.`);
              return remapItemData(response,businessRules);
            });
        }
      })
      .catch((error) => {
        console.error('Error fetching latestRef or item data:', error);
        throw createDEXFRequestError();
      });
  } else {
    response = fetchItemData(prodUrl)
      .then((response) => {
        if (response.length === 0) {
          throw createDEXFRequestError();
        }
        console.log(`Successfully fetched item data for unit: ${country.toUpperCase()} from DEXF.`);
        return remapItemData(response,businessRules);
      });
  }
  return response;
}

const fetchItemData = (url) => fetch(url, {
  headers: {
    Accept: 'application/json',
    'DEXF-API-KEY': apiKey
  },
  credentials: 'same-origin',
}).then((response) => {
  if (response.status != 404) {
    return parseJSON(response);
  }
  return null;
})
const fetchSameOriginItemData = (url) => fetch(url, {
  credentials: 'same-origin',
}).then((response) => {
  if (response.status != 404) {
    return parseJSON(response);
  }
  return null;
})

const fetchSameOriginJson = (url) => fetch(url, {
  credentials: 'same-origin',
})
  .then((response) => {
    if (response.status !== 404) {
      return response.json(); // Directly return the parsed JSON
    }
    return null; // Return null if the file is not found
  })
  .catch((error) => {
    console.error(`Error fetching JSON from ${url}:`, error);
    throw error;
  });

export const dexfGlobalRequest = (country, language) => {
  const prodUrl = `https://api.dexf.ikea.com/webplanner/v1/query/items/retailunit/${country.toUpperCase()}/locale/en-${country.toUpperCase()}?fields=${fields}&filter.appId=${appId}&filter.valid=${validItemsOnly}`;
  const localhostUrl = `/addon-app/cwcalc/items/latest/${country}/${language}/index.json`;
  const cteLatestRefUrl = `/addon-app/cwcalc/items/latest/index.json`;

  let response;

  if(process.env.ITEMS_ENV === 'local'){
    response = fetchItemData(localhostUrl)
      .then((response) => {
        if (response.length === 0) {
          throw createDEXFRequestError();
        }
        console.log(`Successfully fetched global item data for unit: ${country.toUpperCase()} locally.`);
        return createGlobalPropArray(response);
      });
  } else if (isRunningOnCTE) {
    response = fetchSameOriginJson(cteLatestRefUrl)
      .then((latestRef) => {
        console.log('Fetched latestRef for item data:', latestRef);

        const key = `${language.toLowerCase()}_${country.toUpperCase()}`;
        const latestFile = latestRef[key];
        if (latestFile) {
          const fileUrl = `/addon-app/cwcalc/items/${latestFile}.json`;
          console.log('Fetching global item data from:', fileUrl);

          return fetchSameOriginJson(fileUrl)
            .then((response) => {
              if (response) {
                console.log(`Successfully fetched global item data for unit: ${country.toUpperCase()} locally from server.`);
                return createGlobalPropArray(response);
              } else {
                console.log('File not found on server. Falling back to DEXF API.');
                return fetchItemData(prodUrl)
                  .then((response) => {
                    if (response.length === 0) {
                      throw createDEXFRequestError();
                    }
                    console.log(`Successfully fetched global item data for unit: ${country.toUpperCase()} from DEXF.`);
                    return createGlobalPropArray(response);
                  });
              }
            });
        } else {
          console.log(`No latestRef item data entry found for key: ${key}. Falling back to DEXF API.`);
          return fetchItemData(prodUrl)
            .then((response) => {
              if (response.length === 0) {
                throw createDEXFRequestError();
              }
              console.log(`Successfully fetched global item data for unit: ${country.toUpperCase()} from DEXF.`);
              return createGlobalPropArray(response);
            });
        }
      })
      .catch((error) => {
        console.error('Error fetching latestRef or global item data:', error);
        throw createDEXFRequestError();
      });
  } else {
    response = fetchItemData(prodUrl)
      .then((response) => {
        if (response.length === 0) {
          throw createDEXFRequestError();
        }
        console.log(`Successfully fetched global item data for unit: ${country.toUpperCase()} from DEXF.`);
        return createGlobalPropArray(response);
      });
  }
  return response;
}

const parseJSON = (response) => response.json()

export const createGlobalPropArray = (items) => {
  let globalProps = [];
  items.data.forEach((key) => {
    globalProps.push({
      ItemNo: mapItemNo(key.itemId),
      ProductNameGlobal: key.content.name,
      ValidDesignTextGlobal: key.content.validDesignText,
    });
  });
  return globalProps;
}

export const remapItemData = (items, businessRules) => {
  let mappedItems = [];
  items.data.forEach((key) => {
    mappedItems.push(implement(ItemData)({
      ItemNo: mapItemNo(key.itemId),
      ItemType: key.content.itemType ? key.content.itemType.toString() : 'ART',
      ProductName: key.content.name ? key.content.name : '',
      ProductNameGlobal: key.content.name ? key.content.name : '',
      ProductTypeName: key.content.typeName ? key.content.typeName : '',
      ProductTypeNameGlobal: key.content ? mapProductTypeNameGlobal(key.content) : '',
      ValidDesignText: key.content.validDesignText ? key.content.validDesignText : '',
      ValidDesignTextGlobal: key.content.validDesignText ? key.content.validDesignText : '',
      ItemMeasureReferenceTextMetric: key.content.measureReference ? key.content.measureReference.textMetric.toString() : '',
      ItemMeasureReferenceTextImperial: key.content.measureReference ? key.content.measureReference.textImperial.toString() : '',
      ItemUnitCode: mapUnitCode(key.content.measure),
      RetailItemImageList: {
        RetailItemImage: key.content.image ? mapitemImageList(key.content.image) : [],
      },
      RetailItemCommPriceList: {
        RetailItemCommPrice: key.content.priceInformation ? mapitemPricelist(key.content.priceInformation.salesPrice) : [],
      },
      CurrencyRankList: key.content.priceInformation ? mapitemCurrencyList(key.content.priceInformation.currencyRank) : [],
      RetailItemCommFamilyPriceList: {
        RetailItemCommFamilyPrice: key.content.priceInformation ? mapitemFamilyPricelist(key.content.priceInformation.salesPrice) : [],
      },
      RetailItemCommFeeList: {
        RetailItemCommFee: key.content.priceInformation.fees ? mapitemFees(key.content.priceInformation.fees) : [],
      },
      ItemMeasureList: {
        ItemMeasure: key.content.measure ? mapitemMeasurementList(key.content.measure) : [],
      },
      RetailItemCommChildList: {
        RetailItemCommChild: key.content.child ? mapitemChildrenList(key.content.child) : [],
      }
    }));
  });
  return mappedItems;
}

const mapItemNo = (itemId) => {
  return itemId.substring(4, itemId.length);
}

const mapProductTypeNameGlobal = (content) => {
  switch (content.typeCode) {
    case '32968':
      return 'custom made wall panel';
    case '32957':
      return 'custom made worktop';
    case '31499':
      return 'cover panel';
    case '33007':
      return 'hole-making';
    case '33006':
      return 'preparation';
    case '33009':
      return 'additional surface';
    case '17485':
      return 'sink';
    case '34949':
      return 'sink bowl w visible front';
    case '34950':
      return 'sink bowl w visible front';
    case '34947':
      return 'sink bowl, 2 bowls w visible front';
    case '34946':
      return 'sink bowl, 2 bowls w visible front';
    case '32743':
      return 'inset sink, 1 bowl';
    case '34746':
      return 'inset sink, 1 bowl';
    case '32785':
      return 'inset sink, 2 bowls';
    case '11001':
      return 'single-bowl inset sink';
    case '32786':
      return 'onset sink';
    case '32738':
      return 'inset sink, 1 bowl with drainboard';
    case '34749':
      return 'inset sink, 1 bowl with drainboard';
    case '32788':
      return 'inset sink, 1 ½ bowl w drainboard';
    case '32789':
      return 'inset sink, 2 bowls with drainboard';
    case '10999':
      return 'inset sink';
    default:
      return content.typeName;
  }
}

const mapUnitCode = (measurementsList) => {
  if (measurementsList !== null && measurementsList !== undefined) {
    let hasArea = measurementsList.find(o => o.typeCode === '00005');
    let hasMinLength = measurementsList.find(o => o.typeCode === '00002');
    let hasMinHeight = measurementsList.find(o => o.typeCode === '00040');
    if (hasArea !== null && hasArea !== undefined ||
      hasMinLength !== null && hasMinLength !== undefined ||
      hasMinHeight !== null && hasMinHeight !== undefined) {
      return 'METER';
    } else {
      return 'PIECE';
    }
  }
  return 'PIECE';
}

const mapitemImageList = (imageList) => {
  let returnValues = [];
  imageList.forEach((image) => {
    if (image.typeName === 'Main Product Picture') {
      returnValues.push({
        ImageSize: image.size,
        ImageUrl: image.url.replace('https://ikea.marat.qd.je', ''),
        SortNo: image.sortNo,
        ImageType: "Picture Single"
      });
    } else {
      returnValues.push({
        ImageSize: image.size,
        ImageUrl: image.url.replace('https://ikea.marat.qd.je', ''),
        SortNo: image.sortNo,
        ImageType: image.typeName
      });
    }
  });
  return returnValues;
}

const mapitemPricelist = (priceList) => {
  let returnValues = [];
  if (priceList !== null && priceList !== undefined) {
    priceList.forEach((price) => {
      if (price.typeCode !== "IKEAFamilySalesUnitPrice") {
        returnValues.push({
          Price: price.priceInclTax,
          PriceExclTax: price.priceExclTax,
          CurrencyCode: price.currencyCode,
        });
      }
    });
  }
  return returnValues;
}

const mapitemCurrencyList = (currencyList) => {
  let returnValues = [];
  if (currencyList !== null && currencyList !== undefined) {
    currencyList.forEach(currency => returnValues.push(currency))
  }
  return returnValues;
}

const mapitemFamilyPricelist = (priceList) => {
  let returnValues = [];
  if (priceList !== null && priceList !== undefined) {
    priceList.forEach((price) => {
      if (price.typeCode === "IKEAFamilySalesUnitPrice") {
        returnValues.push({
          FamilyPrice: price.priceInclTax,
          FamilyPriceExclTax: price.priceExclTax,
          CurrencyCode: price.currencyCode,
          ValidFromDateTime: price.validFromDateTime,
          ValidToDateTime: price.validToDateTime,
        });
      }
    });
  }
  return returnValues;
}

const mapitemFees = (feeList) => {
  let returnValues = [];
  if (feeList !== null && feeList !== undefined) {
    feeList.forEach((fee) => {
      returnValues.push({
        Type: fee.typeCode,
        Amount: fee.amount,
        CurrencyCode: fee.currencyCode,
      });
    });
  }
  return returnValues;
}

const mapitemMeasurementList = (measurementsList) => {
  let returnValues = [];
  if (measurementsList !== null && measurementsList !== undefined) {
    measurementsList.forEach((measurement) => {
      let val = {
        ItemMeasureTypeNameEn: '',
        ItemMeasureValue: measurement.value,
        ItemMeasureValueUnit: ''
      }

      switch (measurement.typeCode) {
        case '00035':
          val.ItemMeasureTypeNameEn = 'Thickness';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00081':
          val.ItemMeasureTypeNameEn = 'Max. depth';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00043':
          val.ItemMeasureTypeNameEn = 'Min. depth';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00003':
          val.ItemMeasureTypeNameEn = 'Max. length';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00002':
          val.ItemMeasureTypeNameEn = 'Min. length';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00001':
          val.ItemMeasureTypeNameEn = 'Length';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00407':
          val.ItemMeasureTypeNameEn = 'Bowl, depth';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00406':
          val.ItemMeasureTypeNameEn = 'Bowl, width';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00405':
          val.ItemMeasureTypeNameEn = 'Bowl, front to back';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00404':
          val.ItemMeasureTypeNameEn = 'Cut-out measurement width';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00403':
          val.ItemMeasureTypeNameEn = 'Cut-out measurement length';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00386':
          val.ItemMeasureTypeNameEn = 'Front to back';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00041':
          val.ItemMeasureTypeNameEn = 'Height';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00008':
          val.ItemMeasureTypeNameEn = 'Volume';
          val.ItemMeasureValueUnit = 'ml';
          break;
        case '00044':
          val.ItemMeasureTypeNameEn = 'Depth';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00040':
          val.ItemMeasureTypeNameEn = 'Min. height';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00082':
          val.ItemMeasureTypeNameEn = 'Max. height';
          val.ItemMeasureValueUnit = 'mm';
          break;
        case '00005':
          val.ItemMeasureTypeNameEn = 'Area';
          val.ItemMeasureValueUnit = 'cm²';
          break;
        case '00047':
          val.ItemMeasureTypeNameEn = 'Width';
          val.ItemMeasureValueUnit = 'mm';
          break;
        default:
          val.ItemMeasureTypeNameEn = measurement.typeName;
          val.ItemMeasureValueUnit = measurement.unit;
      }
      returnValues.push(val);
    });
  }
  return returnValues;
}

const mapitemChildrenList = (childrenList) => {
  let returnValues = [];
  if (childrenList !== null && childrenList !== undefined) {
    childrenList.forEach((child) => {
      returnValues.push({
        Quantity: child.quantity,
        ItemNo: child.itemId.replace('ART-', ''),
        ItemType: 'ART'
      });
    });
  }
  return returnValues;
}
